import { assetUrl } from '../config/asset-config';

(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('vidPlayer', ['$timeout', '$q', '$window', function ajaxFactory($timeout, $q, $window) {
            var videoId;
            var isPlaying;
            var pauseOnPlay;
            var completed = false;

            this.init = function (vidId, url, additionalOptions, captions) {
                videoId = vidId;

                isPlaying = false;
                pauseOnPlay = false;

                var options = {
                    width: '100%',
                    aspectratio: '4:3',
                    skin: {
                        name: 'thankview',
                    },
                };

                if (captions) {
                    options.tracks = [{
                        file: captions,
                        label: 'Captions On',
                        kind: 'captions',
                        default: additionalOptions.autoplayCaptions,
                    }];
                }

                if (url) {
                    options.file = url.replace('d310lx2axip3m3.cloudfront.net', assetUrl(''));
                }

                if (additionalOptions) {
                    options = angular.extend(options, additionalOptions);
                }

                var deferred = $q.defer();
                jwplayer(videoId).setup(options).on('setupError', function (event) {
                    deferred.reject(event.message);

                    if ($window.Bugsnag) {
                        Bugsnag.notify(new Error('jwplayer setup error ' + event.message), (bugsnagEvent) => {
                            bugsnagEvent.addMetadata('custom', { event: event });
                        });
                    }
                });

                jwplayer(videoId).on('play', function () {
                    if (!pauseOnPlay) {
                        isPlaying = true;
                    } else {
                        jwplayer(videoId).pause(true);
                        pauseOnPlay = false;
                    }

                    completed = false;
                });

                return deferred.promise;
            };

            this.play = function () {
                jwplayer(videoId).play(true);
                jwplayer(videoId).seek(0);
            };

            this.seek = function (time) {
                jwplayer(videoId).seek(time);
            };

            this.stop = function () {
                if (!videoId) {
                    return;
                }

                if (isPlaying) {
                    jwplayer(videoId).pause(true);
                    isPlaying = false;
                } else {
                    pauseOnPlay = true;
                }
            };

            this.forceStop = function () {
                if (!videoId) {
                    return;
                }

                if (isPlaying) {
                    jwplayer(videoId).stop();
                    isPlaying = false;
                } else {
                    pauseOnPlay = true;
                }
            };

            this.onReady = function (callback) {
                jwplayer(videoId).on('ready', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onPlay = function (callback) {
                jwplayer(videoId).on('play', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onFirstFrame = function (callback) {
                jwplayer(videoId).on('firstFrame', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onTime = function (callback) {
                jwplayer(videoId).on('time', function (time) {
                    if (typeof callback === 'function') {
                        callback(time);
                    }
                });
            };

            this.onBuffer = function (callback) {
                jwplayer(videoId).on('buffer', function (time) {
                    if (typeof callback === 'function') {
                        callback(time);
                    }
                });
            };

            this.onPause = function (callback) {
                jwplayer(videoId).on('pause', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onDisplayClick = function (callback) {
                jwplayer(videoId).on('displayClick', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onIdle = function (callback) {
                jwplayer(videoId).on('idle', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onMute = function (callback) {
                jwplayer(videoId).on('mute', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onComplete = function (callback) {
                jwplayer(videoId).on('complete', function () {
                    if (typeof callback === 'function' && !completed) {
                        completed = true;
                        callback();
                    }
                });

                jwplayer(videoId).on('idle', function (data) {
                    if (typeof callback === 'function' && !completed && data.reason === 'complete') {
                        completed = true;
                        callback();
                    }
                });
            };

            this.onError = function (callback) {
                jwplayer(videoId).on('error', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onSeek = function (callback) {
                jwplayer(videoId).on('seek', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.onSetupError = function (callback) {
                jwplayer(videoId).on('setupError', function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            };

            this.setControls = function (param) {
                jwplayer(videoId).setControls(param);
            };

            this.getTime = function () {
                return jwplayer(videoId).getPosition();
            };

            this.getState = function () {
                return jwplayer(videoId).getState();
            };

            this.getMute = function () {
                return jwplayer(videoId).getMute();
            };

            this.getVolume = function () {
                return jwplayer(videoId).getVolume();
            };

            this.setVolume = function (perc) {
                return jwplayer(videoId).setVolume(perc);
            };

            this.setType = function (type) {
                this.type = type;
            };

            this.getType = function () {
                return this.type;
            };

            this.remove = function () {
                jwplayer(videoId).remove();
            };

            this.setAudio = function (bool) {
                var q = $q.defer();

                var player = jwplayer(videoId);

                player.setMute(!bool);

                if (bool) {
                    if (player.getVolume() < 70) {
                        player.setVolume(70);
                    }

                    $timeout(function () {
                        var time = player.getCurrentTime();
                        var didStart = time > 0;

                        q.resolve(didStart);
                    }, 500);
                } else {
                    q.resolve(true);
                }

                return q.promise;
            };

            return this;
        }]);
}());
